import { EBarcodeTypes, IBarcodeProps } from './entities/IBarcodeProps';

import { QRCodeSVG } from 'qrcode.react';
import Barcode from 'react-barcode';

const BCBarcode = (props: IBarcodeProps) => {
	const renderImage = () => {
		if (props.value) {
			if (props.codeType == EBarcodeTypes.QR) {
				return <QRCodeSVG value={props.value} />;
			} else {
				return (
					<Barcode
						value={props.value}
						displayValue={false}
						background="transparent"
					/>
				);
			}
		}
	};

	return <div style={props.style}>{renderImage()}</div>;
};

export default BCBarcode;
export { EBarcodeTypes, IBarcodeProps };
